import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	getColumnChart: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getAreaColumnChart: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getAreaColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getTBTAgreements: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getTBTAgreements', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getTBTStatementOfImplementation: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getTBTStatementOfImplementation', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getTBTCodeOfGoodPractice: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getTBTCodeOfGoodPractice', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getSPSRecognitionOfEquivalence: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getSPSRecognitionOfEquivalence', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getSPSSupplement: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getSPSSupplement', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getICSCodesForTreemap: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getICSCodesForTreemap', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getHSCodesForTreemap: async (parameter) => {
		return await commonApi().get('/v1/memberProfiles/getHSCodesForTreemap', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
}